.CodeMirror {
  line-height: 1.5;
  min-height: 200px;
  max-height: 222px;
  padding: 20px 0px;
  background-color: transparent !important;
  .CodeMirror-hscrollbar {
    overflow: hidden;
  }
  .CodeMirror-vscrollbar {
    overflow: hidden;
  }
  .CodeMirror-gutters {
    background-color: transparent !important;
  }
  .CodeMirror-sizer {
    margin-bottom: 50px !important;
  }
  &.CodeMirror-linenumbers {
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
  }
}
